import Swiper, { A11y, Keyboard, Navigation } from 'swiper';

import '../../sass/template-parts/portfolio-carousel.scss';

const noMotionPreference = window.matchMedia('(prefers-reduced-motion: no-preference)');

(() => {
    const $portfolioCarousels = document.querySelectorAll('.portfolio-carousel');

    if (!$portfolioCarousels) return;

    $portfolioCarousels.forEach($portfolioCarousel => {
        const $carousel = $portfolioCarousel.querySelector('.portfolio-carousel__carousel');
        const $carouselSlides = $portfolioCarousel.querySelectorAll('.portfolio-carousel__slide');
        const $carouselNext = $portfolioCarousel.querySelector('.portfolio-carousel__navigation-next');

        const initCarousel = () => {
            const carousel = new Swiper($carousel, {
                modules: [ A11y, Keyboard, Navigation ],
                slidesPerView: 'auto',
                keyboard: {
                    enabled: true,
                    onlyInViewport: true
                },
                speed: noMotionPreference.matches ? 300 : 0
            });

            console.log($carouselNext);

            if ($carouselNext && $carouselSlides?.length) {
                $carouselNext.addEventListener('click', () => {
                    const endIndex = window.innerWidth >= 1164 ? carousel.activeIndex + 3 : carousel.activeIndex + 2;

                    if (endIndex < $carouselSlides.length) {
                        carousel.slideNext();
                    } else {
                        carousel.slideTo(0);
                    }
                });
            }
        }

        initCarousel();
    })
})();
